import type { SVGProps } from 'react'
import { cn } from '#app/utils/misc'
import type { CustomSvgName } from '../svg-config'
import { getCustomSvgPath } from '../svg-config'

const sizeClassName = {
	font: 'size-[1em]',
	xs: 'size-3',
	sm: 'size-4',
	md: 'size-5',
	lg: 'size-6',
	xl: 'size-7',
} as const

type Size = keyof typeof sizeClassName

const childrenSizeClassName = {
	font: 'gap-1.5',
	xs: 'gap-1.5',
	sm: 'gap-1.5',
	md: 'gap-2',
	lg: 'gap-2',
	xl: 'gap-3',
} satisfies Record<Size, string>

interface CustomSvgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	name: CustomSvgName
	size?: Size
	title?: string
	children?: React.ReactNode
}

/**
 * CustomSvg Component
 * Renders SVG images from the public/img directory
 * Similar to the Icon component but for custom SVGs
 */
export function CustomSvg({
	name,
	size = 'font',
	className,
	title,
	children,
	...props
}: CustomSvgProps) {
	const svgPath = getCustomSvgPath(name)

	if (children) {
		return (
			<span
				className={`inline-flex items-center ${childrenSizeClassName[size]}`}
			>
				<CustomSvg
					name={name}
					size={size}
					className={className}
					title={title}
					{...props}
				/>
				{children}
			</span>
		)
	}

	return (
		<img
			{...props}
			src={svgPath}
			alt={title || name}
			className={cn(sizeClassName[size], 'inline self-center', className)}
			data-custom-svg={name}
		/>
	)
}
